// Add your custom JS here.

(function ($) {
  $(window).on("load resize", function () {});
  function checkHeight(ele) {
    var h = 0;
    $(ele).each(function () {
      if ($(this).height() > h) {
        h = $(this).height();
      }
    });
    $(ele).css("height", h + "px");
  }

  // function setFullHeight() {
  //     document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);

  //     setTimeout(() => {
  //         const uberMega = document.querySelectorAll('.ubermenu-submenu-type-mega');
  //         if(uberMega) {
  //             const vw = window.innerWidth;
  //             const headerContainer = document.querySelector('.header .container').clientWidth + 24;
  //             uberMega.forEach(elem => {
  //                 elem.style.padding = `24px ${(vw - headerContainer)/2}px`;
  //             });
  //         }
  //     }, 1000);

  // }

  // window.addEventListener('resize', setFullHeight);
  // setFullHeight();

  $(document).ready(function () {
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 100) {
        $(".toTop").addClass("active");
      } else {
        $(".toTop").removeClass("active");
      }

      if ($(window).scrollTop() > 5) {
        $(".header").addClass("fixed");
      } else {
        $(".header").removeClass("fixed");
      }
    });

    $(".toTop").on("click", function (e) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        "swing",
      );
    });

    $(".menu-item-has-children").append(
      '<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>',
    );

    $(document).on("click", ".btnSub", function (e) {
      e.preventDefault();
      $(this).toggleClass("active").siblings(".subMenu").slideToggle(300);
    });

    $(document).on("click", ".toggleMenu", function (e) {
      e.preventDefault();
      $(".header__search").removeClass("active");
      $(".header__fixed").toggleClass("active");
    });

    $(document).on("click", ".toggleSea", function (e) {
      e.preventDefault();
      $(".header__fixed").removeClass("active");
      $(".header__search").toggleClass("active");
    });

    if ($(".hero-slider").length) {
      const heroSlider = new Swiper(".hero-slider", {
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 1500,
        loop: true,
        pagination: {
          el: ".hero-slider .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".hero-slider .swiper-button-next",
          prevEl: ".hero-slider .swiper-button-prev",
        },
      });
    }

    if ($(".homeService__slider").length) {
      const homeService__slider = new Swiper(".homeService__slider", {
        slidesPerView: 3,
        spaceBetween: 70,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 800,
        navigation: {
          nextEl: ".homeService__slider .swiper-button-next",
          prevEl: ".homeService__slider .swiper-button-prev",
        },
        pagination: {
          el: ".homeService__slider .swiper-pagination",
          clickable: true,
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          // when window width is >= 640px
          991: {
            slidesPerView: 3,
            spaceBetween: 70,
          },
        },
      });
      $(".homeService__slider")
        .on("mouseover", function () {
          homeService__slider.autoplay.stop();
        })
        .on("mouseout", function () {
          homeService__slider.autoplay.start();
        });
    }

    if ($(".logo-carousel").length) {
      new Swiper(".logo-carousel", {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed: 6000,
        freeMode: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          640: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 9,
            spaceBetween: 60,
          },
        },
      });
    }

    if ($(".feedback__slider").length) {
      const feedback__slider = new Swiper(".feedback__slider", {
        slidesPerView: 3,
        spaceBetween: 70,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 800,
        navigation: {
          nextEl: ".feedback__slider .swiper-button-next",
          prevEl: ".feedback__slider .swiper-button-prev",
        },
        pagination: {
          el: ".feedback__slider .swiper-pagination",
          clickable: true,
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          // when window width is >= 640px
          991: {
            slidesPerView: 3,
            spaceBetween: 70,
          },
        },
      });
      // $('.feedback__slider').on('mouseover', function () {
      //     feedback__slider.autoplay.stop();
      // }).on('mouseout', function () {
      //     feedback__slider.autoplay.start();
      // });
    }

    if ($(".abCer__slider").length) {
      const abCer__slider = new Swiper(".abCer__slider", {
        slidesPerView: 4,
        spaceBetween: 200,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 800,
        navigation: {
          nextEl: ".abCer__slider .swiper-button-next",
          prevEl: ".abCer__slider .swiper-button-prev",
        },
        pagination: {
          el: ".abCer__slider .swiper-pagination",
          clickable: true,
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          // when window width is >= 640px
          991: {
            slidesPerView: 4,
            spaceBetween: 200,
          },
        },
      });
    }

    if ($(".archivePage__childTerm").length) {
      const archivePage__childTerm = new Swiper(".archivePage__childTerm", {
        slidesPerView: 6,
        spaceBetween: 24,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 800,
        navigation: {
          nextEl: ".archivePage__childTerm .swiper-button-next",
          prevEl: ".archivePage__childTerm .swiper-button-prev",
        },
        pagination: {
          el: ".archivePage__childTerm .swiper-pagination",
          clickable: true,
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          // when window width is >= 640px
          991: {
            slidesPerView: 6,
            spaceBetween: 24,
          },
        },
      });
    }

    if ($(".listProject__slider").length) {
      const listProject__slider = new Swiper(".listProject__slider", {
        slidesPerView: 4,
        spaceBetween: 24,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 800,
        navigation: {
          nextEl: ".listProject__slider .swiper-button-next",
          prevEl: ".listProject__slider .swiper-button-prev",
        },
        pagination: {
          el: ".listProject__slider .swiper-pagination",
          clickable: true,
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          // when window width is >= 640px
          991: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
      });
    }

    if ($(".singleProd__images").length) {
      const prodThumbs = new Swiper(".singleProd__thumbs", {
        loop: true,
        spaceBetween: 24,
        slidesPerView: 5,
        watchSlidesProgress: true,
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          // when window width is >= 640px
          991: {
            slidesPerView: 5,
            spaceBetween: 24,
          },
        },
      });
      const prodImages = new Swiper(".singleProd__images", {
        loop: true,
        spaceBetween: 10,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: ".singleProd__images .swiper-button-next",
          prevEl: ".singleProd__images .swiper-button-prev",
        },
        pagination: false,
        thumbs: {
          swiper: prodThumbs,
        },
      });
    }

    function runCounter($element) {
      if (!$element.hasClass("counted")) {
        var numberString = $element.html();
        var cleanedNumberString = numberString.replace(/\./g, "");
        var targetNumber = parseInt(cleanedNumberString, 10);

        if (!isNaN(targetNumber)) {
          $element.addClass("counted");
          $({ countNum: 0 }).animate(
            { countNum: targetNumber },
            {
              duration: 3000,
              easing: "linear",
              step: function () {
                let currentNum = Math.floor(this.countNum);
                let formattedNum = currentNum.toLocaleString("de-DE", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                });
                $element.text(formattedNum);
              },
              complete: function () {
                let formattedTarget = targetNumber.toLocaleString("de-DE", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                });
                $element.text(formattedTarget);
              },
            },
          );
        } else {
          console.error(
            "Lỗi: Không thể chuyển đổi '" + numberString + "' thành số hợp lệ.",
          );
        }
      }
    }

    setTimeout(function () {
      AOS.init({
        duration: 800,
        easing: "ease-in-out",
        once: true,
        offset: 100,
      });
    }, 500);

    if ($(["data-fancybox"]).length) {
      $("data-fancybox").fancybox();
    }

    if ($(".prodContent__body").length) {
      const tableElem = $(".prodContent__body table");
      if (tableElem) {
        setTimeout(() => {
          tableElem.each((idx, elem) => {
            $(elem).wrap('<div class="tableWrap"></div>');
          });
        }, 1000);
      }
    }

    // Search toggle logic for Azerty
    const searchIcon = document.getElementById("searchToggle");
    const searchBar = document.getElementById("searchBar");
    const searchInput = document.getElementById("searchInput");
    const closeSearch = document.getElementById("closeSearch");

    if (searchIcon && searchBar) {
      function toggleSearch(show) {
        if (show === undefined) {
          searchBar.classList.toggle("active");
        } else if (show) {
          searchBar.classList.add("active");
        } else {
          searchBar.classList.remove("active");
        }

        if (searchBar.classList.contains("active") && searchInput) {
          searchInput.focus();
        }
      }

      searchIcon.addEventListener("click", function (e) {
        e.stopPropagation();
        toggleSearch();
      });

      if (closeSearch) {
        closeSearch.addEventListener("click", function () {
          toggleSearch(false);
        });
      }

      // Close search on click outside
      document.addEventListener("click", function (e) {
        if (!searchBar.contains(e.target) && !searchIcon.contains(e.target)) {
          toggleSearch(false);
        }
      });

      // Close search on Escape key
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          toggleSearch(false);
        }
      });
    }

    // Mobile menu toggle logic
    const mobileMenuToggle = document.getElementById("mobileMenuToggle");
    const mobileMenuClose = document.getElementById("mobileMenuClose");
    const mobileMenu = document.getElementById("mobileMenu");
    const sidebarOverlay = document.getElementById("sidebarOverlay");

    function toggleMenu() {
      if (mobileMenu) mobileMenu.classList.toggle("active");
      if (sidebarOverlay) sidebarOverlay.classList.toggle("active");
      if (mobileMenuToggle) mobileMenuToggle.classList.toggle("active");
      document.body.classList.toggle("no-scroll");
    }

    if (mobileMenuToggle) {
      mobileMenuToggle.addEventListener("click", function (e) {
        toggleMenu();
      });
    }

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener("click", function (e) {
        toggleMenu();
      });
    }

    if (sidebarOverlay) {
      sidebarOverlay.addEventListener("click", function (e) {
        toggleMenu();
      });
    }

    // Sticky Header Logic
    const mainHeader = document.querySelector(".main-header");
    if (mainHeader) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 100) {
          mainHeader.classList.add("is-sticky");
        } else {
          mainHeader.classList.remove("is-sticky");
        }
      });
    }

    // Mobile dropdown logic
    const dropdownToggles = document.querySelectorAll(
      ".nav-list__item--dropdown",
    );
    dropdownToggles.forEach((toggle) => {
      const icon = toggle.querySelector(".nav-list__icon");
      const link = toggle.querySelector(".nav-list__link");

      const toggleActive = function (e) {
        if (window.innerWidth <= 1025) {
          e.preventDefault();
          e.stopPropagation();
          toggle.classList.toggle("active");
        }
      };

      if (icon) icon.addEventListener("click", toggleActive);
      if (link) link.addEventListener("click", toggleActive);
    });

    // Language selector logic (Desktop & Mobile)
    const setupLangSelector = (selectorId, textId) => {
      const selector = document.getElementById(selectorId);
      const textElem = document.getElementById(textId);

      if (selector) {
        selector.addEventListener("click", function (e) {
          e.stopPropagation();
          this.classList.toggle("active");
          const dropdown = this.querySelector(".dropdown-menu");
          if (dropdown) dropdown.classList.toggle("active");
        });

        const langLinks = selector.querySelectorAll(".dropdown-menu__link");
        langLinks.forEach(link => {
          link.addEventListener("click", function (e) {
            e.preventDefault();
            const langCode = this.getAttribute("data-gt-lang");
            const defaultLang = selector.getAttribute("data-default-lang") || 'en';
            
            if (typeof window.doGTranslate === 'function') {
              window.doGTranslate(`${defaultLang}|${langCode}`);
            }

            if (textElem) {
              textElem.textContent = this.textContent;
            }
          });
        });

        // Sync initial text
        const getCurrentLang = () => {
          const match = document.cookie.match(/googtrans=\/([^/]+)\/([^/]+)/);
          if (match && match[2]) return match[2];
          const pathParts = window.location.pathname.split('/');
          if (pathParts[1] && pathParts[1].length === 2) return pathParts[1];
          return 'en';
        };

        const currentLangCode = getCurrentLang();
        const activeLink = selector.querySelector(`[data-gt-lang="${currentLangCode}"]`);
        if (activeLink && textElem) {
          textElem.textContent = activeLink.textContent;
        }
      }
    };

    setupLangSelector("langSelector", "currentLangText"); // Desktop
    setupLangSelector("langSelectorMobile", "currentLangTextMobile"); // Mobile

    // Close all lang dropdowns when clicking outside
    document.addEventListener("click", function () {
      const allSelectors = document.querySelectorAll(".main-nav__lang-selector");
      allSelectors.forEach(sel => {
        sel.classList.remove("active");
        const dropdown = sel.querySelector(".dropdown-menu");
        if (dropdown) dropdown.classList.remove("active");
      });
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const historyWrap = document.querySelector(".aboutHistory__wrap");
    const historyBox = document.querySelector(".aboutHistory__box");
    let isDragging = false;
    let startX;
    let scrollLeft;

    if (historyWrap && historyBox) {
      historyWrap.addEventListener("mousedown", (e) => {
        isDragging = true;
        startX = e.pageX - historyBox.offsetLeft;
        scrollLeft = historyWrap.scrollLeft;
        historyWrap.style.cursor = "grabbing";
      });

      historyWrap.addEventListener("mouseleave", () => {
        isDragging = false;
        historyWrap.style.cursor = "grab";
      });

      historyWrap.addEventListener("mouseup", () => {
        isDragging = false;
        historyWrap.style.cursor = "grab";
      });

      historyWrap.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - historyBox.offsetLeft;
        const walk = (x - startX) * 1; // Điều chỉnh hệ số này để thay đổi tốc độ kéo
        historyWrap.scrollLeft = scrollLeft - walk;
      });
    }
  });

  // Chờ toàn bộ trang và tài nguyên được tải xong
  window.addEventListener("load", () => {
    // Tìm tất cả các phần tử có class 'js-marquee-container' trên trang
    // Bạn cần thêm class này vào các div chứa marquee của mình trong HTML
    const marqueeContainers = document.querySelectorAll(".myMarquee");

    // Lặp qua từng phần tử tìm được và thiết lập marquee cho mỗi phần tử
    marqueeContainers.forEach((marqueeContainer) => {
      // Gọi hàm setupMarquee cho từng container
      setupMarquee(marqueeContainer);
    });
  });

  // Hàm để thiết lập và chạy animation cho một marquee cụ thể
  function setupMarquee(marqueeContainer) {
    // Kiểm tra xem container có tồn tại không
    if (!marqueeContainer) {
      console.error("Marquee container element not provided.");
      return;
    }

    const marqueeWrapper = marqueeContainer.querySelector(".marqueeContainer");
    if (!marqueeWrapper) {
      console.error(
        "Marquee wrapper '.marqueeContainer' not found inside the provided container.",
        marqueeContainer,
      );
      return;
    }

    const originalItems = Array.from(marqueeWrapper.children);
    if (originalItems.length === 0) {
      console.warn(
        "Marquee wrapper has no child elements inside container.",
        marqueeContainer,
      );
      return; // Không có phần tử để tạo hiệu ứng
    }

    // --- Cấu hình (Có thể lấy từ data- attribute nếu muốn tùy chỉnh cho từng marquee) ---
    // Đọc cấu hình từ data- attribute trên container (nếu có) hoặc dùng giá trị mặc định
    const speed = parseFloat(marqueeContainer.dataset.speed) || 80; // pixels per second
    const direction = parseInt(marqueeContainer.dataset.direction) || -1; // -1: Left, 1: Right
    const pauseOnHover = marqueeContainer.dataset.pauseOnHover !== "false"; // Mặc định là true trừ khi là 'false'

    // --- Nhân bản các phần tử ---
    // Xóa các phần tử nhân bản cũ nếu hàm được gọi lại (ví dụ: trong quá trình phát triển)
    // Giữ lại số lượng phần tử ban đầu
    while (marqueeWrapper.children.length > originalItems.length) {
      marqueeWrapper.removeChild(marqueeWrapper.children[originalItems.length]);
    }

    // Nhân bản các phần tử ban đầu
    originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      // Tùy chọn: Thêm class hoặc attribute để nhận diện bản sao
      // clone.setAttribute('data-clone', 'true');
      marqueeWrapper.appendChild(clone);
    });

    // --- Tính toán chiều rộng và thời lượng dựa trên chiều rộng thực tế sau khi render ---
    // Sử dụng requestAnimationFrame để đảm bảo các style và layout đã được tính toán xong
    requestAnimationFrame(() => {
      // Đo tổng chiều rộng của wrapper chứa cả phần tử gốc + bản sao
      const totalWidth = marqueeWrapper.scrollWidth;

      // Chiều rộng cần thiết cho một chu kỳ chạy là chiều rộng của các phần tử gốc
      // Vì đã nhân đôi, chiều rộng của phần tử gốc là một nửa totalWidth
      const resetWidth = totalWidth / 2; // Đây là chiều rộng của nội dung gốc (trước khi nhân đôi)

      // Kiểm tra xem nội dung có đủ rộng để cuộn hay không
      if (resetWidth <= 0 || resetWidth <= marqueeContainer.offsetWidth) {
        // console.warn("Marquee content is not wide enough to scroll or width calculation failed for container.", marqueeContainer);
        // Xóa các bản sao nếu không cuộn
        while (marqueeWrapper.children.length > originalItems.length) {
          marqueeWrapper.removeChild(
            marqueeWrapper.children[originalItems.length],
          );
        }
        // Tùy chọn: Thêm style để nội dung hiển thị bình thường nếu không cuộn
        marqueeWrapper.style.animation = "none";
        marqueeWrapper.style.transform = "translateX(0)";
        return; // Không có gì để tạo hiệu ứng
      }

      // Tính toán thời lượng animation (đơn vị miliseconds)
      // Thời lượng = Quãng đường / Tốc độ * 1000
      const duration = speed > 0 ? (resetWidth / speed) * 1000 : 0;

      // Hủy bỏ animation cũ nếu có (trường hợp hàm được gọi lại)
      if (marqueeWrapper.animation) {
        marqueeWrapper.animation.cancel();
      }

      // --- Tạo Animation sử dụng WAAPI ---
      if (duration > 0) {
        // Keyframes cho animation cuộn lặp vô hạn
        // Cuộn từ 0 đến -resetWidth (đối với direction -1)
        // Cuộn từ 0 đến +resetWidth (đối với direction 1 - cần kiểm tra lại logic này)
        // Để đảm bảo lặp mượt, điểm bắt đầu và kết thúc cần cách nhau đúng bằng resetWidth
        // Nếu cuộn sang trái (-1): Bắt đầu 0px, Kết thúc -resetWidth px
        // Nếu cuộn sang phải (1): Bắt đầu -resetWidth px, Kết thúc 0px HOẶC Bắt đầu 0px, Kết thúc +resetWidth px (cần điều chỉnh CSS overflow/position)
        // Với setup hiện tại, cuộn sang trái là phổ biến và dễ setup nhất với translateX(0) -> translateX(-resetWidth)
        let keyframes;
        if (direction === -1) {
          // Cuộn sang trái
          keyframes = [
            { transform: "translateX(0)" },
            { transform: "translateX(" + -resetWidth + "px)" },
          ];
        } else {
          // Cuộn sang phải (cần điều chỉnh lại một chút logic hoặc CSS để nó mượt)
          // Cách đơn giản nhất cho cuộn phải với clone là cuộn từ -resetWidth -> 0
          keyframes = [
            { transform: "translateX(" + -resetWidth + "px)" },
            { transform: "translateX(0)" },
          ];
          // Điều chỉnh tốc độ nếu cần thiết cho cuộn phải để cảm giác tương tự
          // Hoặc điều chỉnh điểm bắt đầu/kết thúc keyframes và vị trí ban đầu của wrapper
        }

        const animation = marqueeWrapper.animate(keyframes, {
          duration: duration,
          iterations: Infinity, // Lặp vô hạn
          easing: "linear", // Tốc độ đều
        });

        // Lưu đối tượng animation vào phần tử wrapper để dễ truy cập
        marqueeWrapper.animation = animation;

        // --- Xử lý Dừng/Chạy khi di chuột qua ---
        if (pauseOnHover) {
          // Sử dụng function expressions để dễ dàng gỡ bỏ listener sau này nếu cần
          const pauseAnimation = () => marqueeWrapper.animation?.pause();
          const playAnimation = () => marqueeWrapper.animation?.play();

          // Thêm listener vào phần tử container (bao ngoài)
          marqueeContainer.addEventListener("mouseenter", pauseAnimation);
          marqueeContainer.addEventListener("mouseleave", playAnimation);

          // Tùy chọn: Lưu lại listener để có thể gỡ bỏ trong tương lai (ví dụ khi xóa marquee)
          marqueeContainer.animationListeners = {
            pauseAnimation,
            playAnimation,
          };
        }
      } else {
        // Nếu thời lượng bằng 0 (tốc độ bằng 0), đảm bảo xóa bản sao
        while (marqueeWrapper.children.length > originalItems.length) {
          marqueeWrapper.removeChild(
            marqueeWrapper.children[originalItems.length],
          );
        }
        marqueeWrapper.style.animation = "none"; // Đảm bảo không có animation CSS cũ
        marqueeWrapper.style.transform = "translateX(0)"; // Đảm bảo về vị trí ban đầu
      }
    }); // Kết thúc requestAnimationFrame
  }
})(jQuery);
